<!-- 设置联盟商品价格弹出层 -->
<template>
    <div v-loading="loading">
        <div class="set-content">
            <div v-for="item in levelData" :key="item.PriceId" class="set-item">
                <el-input v-model="item.LevelName" class="item-cname" disabled></el-input>
                <el-input v-model="item.Price" class="item-width">
                    <template popper-class="item-width-title" slot="prepend">输入价格</template>
                </el-input>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: right; margin-top: 20px; padding-bottom: 10px">
            <el-button class="search-btn" @click="closeDialog()">取消</el-button>
            <el-button class="search-btn btn-primary" @click="submit">保存价格</el-button>
        </div>
    </div>
</template>
<script>
export default {
    props: ['uGoodsId'],
    components: {},
    data() {
        return {
            loading: false,
            levelData: []
        };
    },
    mounted() {
        if (this.uGoodsId) {
            this.getLevelPriceData();
        } else this.$util.warningMsg('要设置的商品的价格数据异常，请刷新后重新操作');
    },
    methods: {
        submit() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpUnionGoods/SubmitUGoodsPriceLevelData',
                    data: { GoodsPriceList: this.levelData, UGoodsId: this.uGoodsId },
                    hideLoading: true
                })
                .then(res => {
                    this.$util.successMsg(res.errmsg);
                    this.$emit('closeDialog',true);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        closeDialog() {
            this.$emit('closeDialog');
        },
        getLevelPriceData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpUnionGoods/GetUnionGoodsLevelPrices',
                    data: { uGoodsId: this.uGoodsId },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    that.levelData = data;
                })
                .finally(() => {
                    that.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scope>
.set-content {
    display: flex;
    flex-direction: column;

    .set-item {
        display: flex;
        flex-direction: row;
        height: 40px;

        .item-cname2 {
            width: 100% !important;
        }
    }
    .el-input-group__prepend {
        padding: 0 10px;
        border-radius: 0;
    }
    .el-input-group__append {
        padding: 0 10px;
    }
    .el-tag {
        height: 100%;
        width: 100%;
        border-radius: 5px;
        font-size: 14px;
        line-height: 35px;
    }
}
</style>
